import { ApolloClient, InMemoryCache, HttpLink, split } from '@apollo/client';
import { WebSocketLink } from '@apollo/client/link/ws'
import { getMainDefinition } from '@apollo/client/utilities';

const httpURL = 'https://remote-copypaste.herokuapp.com/graphql';
const wsURL = 'wss://remote-copypaste.herokuapp.com/graphql'


const httpLink = new HttpLink({
  uri: httpURL
});

const wsLink = new WebSocketLink({
    uri: wsURL,
    
  options: {
    reconnect: true,
  }
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  httpLink,
);


const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache()
});


export {client};